import { TextWithTooltip } from 'components/WithTooltip';
import { CodeCell } from 'pages/Project/Common/CodeCell';
import type { TableColumn } from 'uikit';
import { formatNumberToRu } from 'utils';

import React from 'react';

import type { IOthersData } from './types';
import { CHAPTER_CONST, TYPE_CONST } from './types';

const defineBalance = (limit: number, balance: number) => {
    const amount = limit - balance;

    if (balance < 0) {
        return {
            color: '#EB3333',
            tooltip: 'Остаток по прочим затратам отрицательный',
        };
    }

    return limit * 0.3 < amount
        ? { color: '#EB6D00', tooltip: 'Остаток по прочим затратам меньше 30%' }
        : { color: '' };
};

export const getAddOthersBaseColumns = (costRounding: number) =>
    [
        {
            title: 'Наименование',
            accessor: 'name',
            align: 'left',
            width: 450,
            renderCell: (row: IOthersData) => <CodeCell status={row.status!} statusLabel={row.name} />,
        },
        {
            title: 'Раздел',
            accessor: 'chapter',
            width: 100,
            renderCell: (row: IOthersData) =>
                (row.chapter && CHAPTER_CONST[row.chapter]) || (row.contractOtherCostId && 'Лимиты Заказчика'),
        },
        {
            title: 'Способ расчета',
            accessor: 'type',
            width: 100,
            renderCell: (row: IOthersData) =>
                (row.calculatingType && TYPE_CONST[row.calculatingType]) ||
                (row.calculatingType && `${row.calculatingTypeValue} %`),
        },
        {
            title: 'Сезон',
            accessor: 'season',
            width: 100,
            renderCell: (row: IOthersData) => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {row?.limits?.map((limit) => (
                        <div key={`${row.id}_${limit.season.year}`} style={{ paddingBottom: 15 }}>
                            {limit.season.year}
                        </div>
                    ))}
                </div>
            ),
            align: 'center',
        },
        {
            title: 'Лимит по Договору',
            accessor: 'limits',
            renderCell: (row: IOthersData) => (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%' }}>
                    {row?.limits?.map((limit) => (
                        <div key={`${row.id}_${limit.season.year}`} style={{ paddingBottom: 15 }}>
                            {formatNumberToRu(limit.costLimit, costRounding)}
                        </div>
                    ))}
                </div>
            ),
            width: 120,
        },
        {
            title: 'Остаток по Договору',
            accessor: 'balance',
            renderCell: (row: IOthersData) => (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%' }}>
                    {row?.limits?.map((limit) => {
                        const { color, tooltip } = defineBalance(limit.costLimit, limit.totalRemainderCost);
                        const labelText = formatNumberToRu(limit.totalRemainderCost, costRounding);

                        return (
                            <div key={`${row.id}_${limit.season.year}`} style={{ paddingBottom: 15 }}>
                                {tooltip ? (
                                    <TextWithTooltip tooltipText={tooltip} text={labelText} tooltipColor={color} />
                                ) : (
                                    labelText
                                )}
                            </div>
                        );
                    })}
                </div>
            ),
            width: 120,
        },
    ] as TableColumn<any>[];
